import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hashicorpVault = defineConnector({
  identifier: "hashicorpVault",
  name: "HashiCorp Vault",
  tagLine: "Secrets management platform",
  keywords: "hcp cloud secrets kv pki dynamic credentials namespaces",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () =>
    "https://(?:[^/]*\\.hashicorp\\.cloud/.*|[^/]*\\.vaultproject\\.io/.*)",
  auth: (app) =>
    headerAuth([
      { name: "X-Vault-Token", value: app.secret.token },
      {
        name: "X-Vault-Namespace",
        value: app.config.namespace,
      },
    ]),
  steps: [
    {
      title: "Get your Vault token",
      items: [
        {
          kind: "markdown",
          content:
            "Create a Vault token with the appropriate policies for your use case. You can generate a token using the Vault CLI or UI.",
        },
      ],
    },
    {
      title: "Enter your Vault details",
      items: [
        {
          kind: "url",
          label: "Vault address",
          required: true,
          placeholder: "https://vault.example.com:8200",
          target: { kind: "configuration", field: "address" },
          helperText: "The base URL of your Vault server.",
        },
        {
          kind: "input",
          label: "Vault token",
          required: true,
          target: { kind: "secrets", field: "token" },
        },
        {
          kind: "input",
          label: "Namespace (optional)",
          required: false,
          target: { kind: "configuration", field: "namespace" },
          helperText: "For Vault Enterprise namespaces.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ address }) => `${address}/v1/sys/health`,
  },
});
